module.exports = __webpack_public_path__ + "assets/img/btn-download-hover-651ac646.png";